export enum ServiceTagEnum {
  CLOUD = 'srv_cloud',
  CLOUD_PRODUCT = 'cloudproduct',
  SIP_TRUNK = 'srv_sip_trunk',
  PHONE_NUMBERS_NEW = 'reqareacode',
  PHONE_NUMBERS_PORTING = 'reqporting',
  CONNECTION = 'srv_connection',
  CONNECTION_PRODUCT = 'conproduct',
  HARDWARE = 'reqhardware',
  MOBILE = 'reqmobile',
  MOBILE_KPN = 'reqmobilekpn',
}
